import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { TabNav } from '@synoptic/ui-kit/tab-nav/tab-nav.tsx';
import { FC, ReactNode } from 'react';
import { UIMatch, useMatches } from 'react-router';
import { PageRichHeader } from '@/components/page-header/page-rich-header.tsx';
import { TabLink } from '@/components/tab-link.tsx';
import { paths } from '@/routes-utils/paths.ts';
import {
  marketplaceHeaderContent,
  marketplaceHeaderTopLine,
  marketplaceNav,
} from '@/routes/_app.p.marketplace/marketplace-header/marketplace-header.css.ts';

export const MarketplaceHeader: FC = () => {
  const isTablet = useIsTablet();
  const matches = useMatches() as UIMatch<
    unknown,
    {
      description?: () => string;
      titleAside?: () => ReactNode;
      filters?: () => ReactNode;
      children?: () => ReactNode;
    }
  >[];

  const description =
    matches.find((m) => m.handle?.description)?.handle?.description?.() ?? '';
  const titleAside =
    matches.find((m) => m.handle?.titleAside)?.handle?.titleAside?.() ?? '';
  const filters =
    matches.find((m) => m.handle?.filters)?.handle?.filters?.() ?? '';
  const children =
    matches.find((m) => m.handle?.children)?.handle?.children?.() ?? '';

  return (
    <PageRichHeader
      className={marketplaceHeaderContent}
      title={'Marketplace'}
      description={description}
      topLineClassName={marketplaceHeaderTopLine}
      titleAside={titleAside}
      filters={filters}
      contentUnderTitle={isTablet ? <MarketplaceHeaderTabs /> : null}
    >
      {children}
    </PageRichHeader>
  );
};

const MarketplaceHeaderTabs = () => {
  return (
    <TabNav className={marketplaceNav}>
      <TabLink to={paths.streams}>Data streams</TabLink>
      <TabLink to={paths.customStreams}>Custom streams</TabLink>
      <TabLink to={paths.streamPackages}>Stream packages</TabLink>
    </TabNav>
  );
};
